import { Box, Link as MuiLink, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

import { useTheme } from '@/theme';

interface BreadcrumbItem {
  label: string;
  path: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

function Breadcrumb({ items }: BreadcrumbProps) {
  const theme = useTheme();

  return (
    <Box component='nav' sx={{ padding: '0 !important' }} aria-label='Breadcrumb' data-testid='breadcrumb'>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          fontSize: 14,
          color: theme.hhglobal.purpose.textWeak,
        }}
      >
        {items.map((item, index) => (
          <Box key={item.path} component='span' sx={{ display: 'flex', alignItems: 'center' }}>
            {index > 0 && (
              <Typography component='span' sx={{ margin: '0 8px', color: theme.hhglobal.purpose.textWeak }}>
                /
              </Typography>
            )}
            {index === items.length - 1 ? (
              <Typography
                component='span'
                sx={{
                  color: theme.hhglobal.purpose.textStrong,
                  fontSize: theme.hhglobal.typography.headings.h4.fontSize,
                  fontWeight: 700,
                }}
              >
                {item.label}
              </Typography>
            ) : (
              <MuiLink
                component={Link}
                to={item.path}
                sx={{
                  color: theme.hhglobal.purpose.textWeak,
                  textDecoration: 'none',
                  transition: 'color 0.2s',
                  padding: '0 !important',
                  '&:hover': {
                    color: theme.hhglobal.purpose.textStrong,
                  },
                }}
                data-testid={`breadcrumb-link-${item.label}`}
              >
                {item.label}
              </MuiLink>
            )}
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default Breadcrumb;
